import * as htmlToImage from "html-to-image"
import * as ReactDOMClient from "react-dom/client"

import { DEFAULT_SIGN_ICON } from "../constants/defaultIcon"
import { MAP_ICON_BORDER_WIDTH, MAP_ICON_PADDING, MAP_ICON_SIZE } from "../constants/mapIcon"

declare global {
    interface Window {
        generatedIcons?: Record<string, string>
    }
}

export const createMapIcon = async (type, map, theme, iconOffset, color, module, iconId = null) => {

    const Icon = module.icon
    const id = iconId ?? `${type}-${color}`
    const rootContainer = document.createElement("div")
    Object.assign(rootContainer.style, {
        boxSizing: "border-box",
        position: "absolute",
        top: "-9999px",
        left: "-9999px",
        width: MAP_ICON_SIZE - MAP_ICON_PADDING + "px",
        height: MAP_ICON_SIZE - MAP_ICON_PADDING + "px",
    })
    document.body.appendChild(rootContainer)

    const root = ReactDOMClient.createRoot(rootContainer)

    root.render(
        <div style={{
            borderRadius: "50%",
            boxSizing: "border-box",
            height: "100%",
            overflow: "hidden",
            position: "relative",
            padding: `${MAP_ICON_PADDING}px`,
            width: "100%",
        }}>
            <div
                style={{
                    backgroundColor: "white",
                    borderRadius: "50%",
                    boxShadow: theme.customShadow("LCS/Shadow-simple"),
                    position: "absolute",
                    inset: 0,
                }}
            />
            <div
                style={{
                    backgroundColor: color,
                    borderRadius: "50%",
                    position: "absolute",
                    top: MAP_ICON_BORDER_WIDTH,
                    left: MAP_ICON_BORDER_WIDTH,
                    width: `calc(100% - ${2 * MAP_ICON_BORDER_WIDTH}px)`,
                    height: `calc(100% - ${2 * MAP_ICON_BORDER_WIDTH}px)`,
                }}
            />
            {Icon ? (
                <Icon
                    style={{
                        width: `calc(100% - ${iconOffset}px)`,
                        height: `calc(100% - ${iconOffset}px)`,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        objectFit: "contain",
                        color: "#fff",
                    }}
                />
            ) : (
                <img
                    alt="default icon"
                    src={DEFAULT_SIGN_ICON}
                    style={{
                        width: `calc(100% - ${iconOffset}px)`,
                        height: `calc(100% - ${iconOffset}px)`,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        objectFit: "contain",
                    }}
                />
            )}
        </div>,
    )

    // Wait so React flushes render
    await new Promise(r => setTimeout(r, 1000))

    try {
        const dataUrl = await htmlToImage.toPng(rootContainer.firstChild as HTMLElement, {
            height: MAP_ICON_SIZE,
            width: MAP_ICON_SIZE,
            pixelRatio: 1,
            skipFonts: true,
        })

        if (!window.generatedIcons) {
            window.generatedIcons = {}
        }
        window.generatedIcons[id] = dataUrl
        map.loadImage(dataUrl, (_, icon) => {
            if (!map.hasImage(id)) {
                map.addImage(id, icon)
            }
        })
    } catch (e) {
        console.error("Error generating icon", e)
    } finally {
        root.unmount()
        document.body.removeChild(rootContainer)
    }
}